import _ from "underscore";

var SelectorUtility = require("lib/shared/SelectorUtility");
var Queries = require("lib/shared/Queries");
var OrgTypes = require("lib/academic/OrgTypes");
var StudentMetrics = require("lib/data/StudentMetrics");

var CurrentUser = require("lib/account/CurrentUser");
var OrgTypes = require("lib/academic/OrgTypes");
var StudentMetrics = require("lib/data/StudentMetrics");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");
var WritingSelectors = require("lib/selectors/WritingSelectors");

export function report({ state, query }) {
	var params = _.extend({}, query);
	var reportKey = $wr.sortedJSON(_.omit(params, "report_lock"));

	return state.reports[reportKey];
}

export function isLoadingReport({ state, query }) {
	var params = _.extend({}, query);
	var reportKey = $wr.sortedJSON(_.omit(params, "report_lock"));

	return state.reports.loading[reportKey];
}

export function digests({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.digests, filters, conditions);		
}

export function digestsByOrg({ state, filters, conditions, orgType }) {
	var dgs = digests({ state, filters, conditions });
	if (!dgs.length) {
		return [];
	}

	if (orgType == OrgTypes.STUDENT_LIST) {
		var orgs = RosterSelectors.studentLists({ state });

	} else if (orgType == OrgTypes.SCHOOL_ORG) {
		var orgs = RosterSelectors.schoolOrgs({ state });
	}

	return orgs.map((org) => {
		if ((orgType == OrgTypes.STUDENT_LIST) || (orgType == OrgTypes.SCHOOL_ORG)) {
			var orgIdentifier = OrgTypes.toIdentifier({ type: orgType, key: org.id });
		}

		var ssIDs = _.pluck(RosterSelectors.studentsForOrgIdentifier({ state, orgIdentifier }), "id");

		var out = {
			start_date: dgs[0].start_date,
			end_date: dgs[0].end_date,
			org_identifier: orgIdentifier
		};

		dgs.filter(x => ssIDs.includes(x.student_id)).forEach((digest) => {
			_.each(digest, (val, key) => {
				var metric = StudentMetrics.inverseLookup(key);

				if (StudentMetrics.isMetric(metric) && StudentMetrics.getType(metric) == "numeric") {
					if (out[key] === undefined) {
						out[key] = 0;
					}
					out[key] += val;
				}
			})
		})

		return out;
	})
}

export function isLoadingDigests({ state, key, userIDs }) {
	// TODO: standardize FE requests
	// for large requests, return true if any digests are in state
	if (userIDs && $wr.isLargeRequest(userIDs)) {
		var digestInState = _.some(_.keys(state.digests), (key) => { return state.digests[key].student_id !== undefined })
		if (digestInState) { return false }
	}

	key = key || "index";
	return state.digests.loading[key];
}

// This function calculates the expectations metrics based on the provided parameters.
export const expectationsMetrics = ({ state, student_list_ids, student_ids }) => {
	if (student_list_ids) {
	  // If student_list_ids is provided, filter the state.studentLists array based on the matching IDs
	  var studentLists = _.filter(state.studentLists, (sl) => _.includes(student_list_ids, sl.id)); // Include only student lists with matching IDs
  
	  // Calculate and return the unique expectations metrics for the selected student lists
	  return _.uniq(_.flatten(_.values(studentLists).map((x) => {
		// Get the grade level expectations metrics for the student list's grade level, or an empty array if not available
		const metrics = (x.prefs || { grade_level_expectations_metrics: {} }).grade_level_expectations_metrics[x.grade_level] || [];
		// Map the metrics to only extract the metric values
		return metrics.map(x => x.metric);
	  })));
	}
	else if (student_ids) {
	  // If student_ids is provided, filter the state.students array to include only students with matching IDs
	  var students = _.filter(state.students, (s) => { return _.includes(student_ids, s.id) })
  
	  // If there are matching students, calculate and return the unique expectations metrics
	  if (!_.isEmpty(students)) {
		// Flatten the expectations metrics arrays, remove duplicates, and return the unique metrics
		return _.uniq(_.flatten(_.values(students).map((x) => {
		  // Get the grade level expectations metrics for the student's grade level, or an empty array if not available
		  const metrics = (x.prefs || { grade_level_expectations_metrics: {} }).grade_level_expectations_metrics[x.grade_level] || [];
		  // Map the metrics to only extract the metric values
		  return metrics.map(x => x.metric);
		})));
	  }
	} else {
	  // If neither student_list_ids nor student_ids is provided, calculate and return the unique expectations metrics for all student lists
	  return _.uniq(_.flatten(_.values(state.studentLists).map((x) => {
		// Get the grade level expectations metrics for the student list's grade level, or an empty array if not available
		const metrics = (x.prefs || { grade_level_expectations_metrics: {} }).grade_level_expectations_metrics[x.grade_level] || [];
		// Map the metrics to only extract the metric values
		return metrics.map(x => x.metric);
	  })));
	}
};
  

export const dashboardOtherMetrics = ({ state, count, aggregate }) => {
	var count = count || 3;
	var cols = CurrentUser.get().prefs.dashboard_columns;

	if (aggregate) {
		cols = _.intersection(
			cols, StudentMetrics.aggregateMetrics()
		).concat(StudentMetrics.aggregateMetrics());
	} else {
		cols = cols.concat(StudentMetrics.DEFAULT_COLUMNS);		
	}
	return _.first(_.uniq(cols), count)
};

export const getExportDataF = ({ state }) => {
	return ({ type, users, schools, startDate, endDate }) => {
		if (type == "goals" || type == "stats" || type == "rld" || type == "all-activities" || type == "expanded-activities" || type == "teacher-picks") {
			var hasExpectations = false;
			
			var studentConditions = {};
			if (users && users.length) {
				studentConditions.ids = users;
			}

			var students = RosterSelectors.students({
				state, 
				conditions: studentConditions
			});
		}
 
		if (type == "goals" || type == "stats") {
			var studentDigests = digests({
				state, 
				filters: { start_date: startDate, end_date: endDate },
				conditions: { id: _.pluck(students, "id") }
			})
			
			if (type == "goals") {
				var metrics = expectationsMetrics({ state });
				hasExpectations = true;
			} else if(type == "stats") {
				var metrics = dashboardOtherMetrics({ state });
			}

			var headers = ["First Name", "Last Name", "Class"];
			metrics.forEach((x) => {
				headers.push(StudentMetrics.getLabel(x));
				if (hasExpectations) {
					headers.push(StudentMetrics.getLabel(x) + " Goal");
				}
			});
			var rows = [];

			students.forEach((student) => {
				var studentList = RosterSelectors.studentList({ state, id: student.student_list_ids.primary });
				var digest = studentDigests.find(x => x.student_id === student.id);
				var row = {
					"First Name": student.first_name,
					"Last Name": student.last_name,
					"Class": (studentList ? studentList.name : "-")
				}

				var dateSpans = student.expectations_date_spans || [];
				var matchTimePeriod = _.filter(dateSpans, (span) => {
					return (span.start == startDate) && (span.end == endDate);
				}).length > 0;
				var grade_level = student && student.grade_level ? parseInt(student.grade_level) : 5
				var expectationMetrics = _.pluck(student.prefs.grade_level_expectations_metrics[grade_level], "metric");

				metrics.forEach((metric) => {
					var label = StudentMetrics.getLabel(metric);
					row[label] = StudentMetrics.getValue(digest, metric);

					var isExpectationForStudent = hasExpectations && matchTimePeriod && _.contains(expectationMetrics, metric);
						
					if (isExpectationForStudent) {
						var grade_level = student && student.grade_level ? parseInt(student.grade_level) : 5
						var expectation = student.prefs.grade_level_expectations_metrics[grade_level].find(x => x.metric === metric) || {};
						row[label + " Goal"] = expectation.goal;
					}
				})
				rows.push(row);
			})
		} else if (type == "rld") {
			// headers - dates of assessment.
			var headers = ["First Name", "Last Name", "Class", "Current Reading Level"];
			var studentIDs = students.map((student) => {
				return student.id;
			})
			var assessmentDates = ReadingSelectors.assessmentDates({
				state,
				conditions: { userIDs: studentIDs },
				sinceSchoolYear: true, untilPresent: true
			})
			
			assessmentDates.map((assessmentDate) => {
				headers.push(assessmentDate)
			})
			var rows = [];
			students.map((student) => {
				var studentList = RosterSelectors.studentList({ state, id: student.student_list_ids.primary });
				var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
				var readingLevel = ReadingLevelFormat.getLexileScoreForFormat(
					student.current_reading_level, readingLevelFormat
				);
				var row = {
					"First Name": student.first_name,
					"Last Name": student.last_name,
					"Class": (studentList ? studentList.name : "-"),
					"Current Reading Level": readingLevel
				}
				var readingLevels = ReadingSelectors.readingLevels({
					state,
					conditions: studentIDs
				})
				// return _.sortBy(matches, "created_at").reverse()[0];
				assessmentDates.map((assessmentDate) => {
					var matches = _.where(readingLevels, { student_id: student.id, assessment_date: assessmentDate })
					if (matches.length > 0) {
						var readingLevel = ReadingLevelFormat.getLexileScoreForFormat(
							matches[0].reading_level, readingLevelFormat
						);
						row[assessmentDate] = readingLevel;
					}
				})

				rows.push(row)
			})
		} else if (type == "all-activities") {
			// headers - dates of assessment.
			var headers = ["First Name", "Last Name", "Class", "Assigned Exercises", "Completed Exercises", "Teacher Picks Assigned", "Teacher Picks Completed"];
			var studentIDs = students.map((student) => {
				return student.id;
			})

			var tasks = WritingSelectors.tasks({
				state,
				conditions: { userIDs: studentIDs }
			})

			var rows = [];
			students.map((student) => {
				var studentList = RosterSelectors.studentList({ state, id: student.student_list_ids.primary });
				var taskItems = _.pluck(_.where(tasks, { user_id: student.id, subject_type: 'exercise' }), 'task_items')
				taskItems = [...new Set(taskItems.flat())];
				
				var taskItemExercises = _.where(taskItems, { subject_type: 'exercise' })
				var standAloneExercises = _.where(tasks, { subject_type: 'exercise', user_id: student.id })
				
				var allExercises = taskItemExercises.concat(standAloneExercises)
				var row = {
					"First Name": student.first_name,
					"Last Name": student.last_name,
					"Class": (studentList ? studentList.name : "-"),
					"Assigned Exercises": _.size(allExercises),
					"Completed Exercises": _.size(_.where(allExercises, {draft: false})),
					"Assigned Teacher Picks": _.size(taskItemExercises),
					"Completed Teacher Picks": _.size(_.where(taskItemExercises, { draft: false }))
				}
				rows.push(row)
			})
		} else if (type == "expanded-activities") {
			// headers - dates of assessment.
			var headers = ["First Name", "Last Name", "Class", "Assigned Date", "Due Date", "Text Title", "Exercise Title", "Skill Set", "Format", "Complete"];
			var studentIDs = students.map((student) => {
				return student.id;
			})

			var tasks = WritingSelectors.tasks({
				state,
				conditions: { userIDs: studentIDs }
			})

			var responses = WritingSelectors.responses({
				state,
				conditions: { userIDs: studentIDs }
			})

			var activities = WritingSelectors.activities({ state })

			var books = ReadingSelectors.books({ state })

			var rows = [];
			students.map((student) => {
				var studentList = RosterSelectors.studentList({ state, id: student.student_list_ids.primary });
				var studentTasks = _.where(tasks, {user_id: student.id})
				var studentResponses = _.where(responses, {user_id: student.id})

				// incomplete tasks would not be pulled by responses
				var incompleteTasks = _.where(studentTasks, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, completed_at: null })
				var incompleteTaskItems = _.filter(_.pluck(studentTasks, 'task_items'), (task_item) => {
					if (task_item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE && task_item.draft) {
						return task_item
					}
				})
				incompleteTasks = incompleteTasks.concat(incompleteTaskItems)
				var allExercises = _.compact(studentResponses.concat(incompleteTasks))

				var allExerciseData = _.map(allExercises, (item) => {
					var activityData = {}
					activityData.created_at = item.created_at ? item.created_at : null
					activityData.due_date = item.due_date ? item.due_date : null
					activityData.text_id = item.text_id ? item.text_id : null
					activityData.activity_id = item.activity_id ? item.activity_id : parseInt(item.subject_id)
					activityData.response_id = item.activity_id ? item.id : null
					activityData.completed_at = item.completed_at ? item.completed_at : null
					activityData.user_id = item.user_id ? item.user_id : null

					return activityData
				})
				_.each(allExerciseData, (data) => {
					var activity = _.findWhere(activities, { id: data.activity_id })
					var book = _.findWhere(books, { text_id: data.text_id })
					var row = {
						"First Name": student.first_name,
						"Last Name": student.last_name,
						"Class": (studentList ? studentList.name : "-"),
						"Assigned Date": (data.created_at ? data.created_at : "-"),
						"Due Date": (data.due_date ? data.due_date : "-"),
						"Text Title": (book ? book.title : "-"),
						"Exercise Title": (activity && activity.format_summary ? activity.format_summary.title : "-"),
						"Skill Set": (activity && activity.format_summary ? activity.format_summary.skillset : "-"),
						"Format": (activity && activity.format_summary ? activity.format_summary.format_class : "-"),
						"Complete": (data.completed_at ? "true" : "false"),
					}
					rows.push(row)
				})
			})
		} else if (type == "teacher-picks") {
			// headers - dates of assessment.
			var headers = ["First Name", "Last Name", "Class", "Assigned Date", "Due Date", "Text Title", "Quiz Score", "Exercises", "Practice Questions", "Review", "Complete"];
			var studentIDs = students.map((student) => {
				return student.id;
			})

			var teacherPicks = WritingSelectors.teacherPicksTasks({
				state,
				conditions: { userIDs: studentIDs }
			})
			var quizzes = WritingSelectors.quizzes({ state })
			var books = ReadingSelectors.books({ state })

			var rows = [];
			students.map((student) => {
				var studentList = RosterSelectors.studentList({ state, id: student.student_list_ids.primary });
				var studentTeacherPicks = _.where(teacherPicks, {user_id: student.id})
				var tearcherPicksTaskItems = _.pluck(studentTeacherPicks, 'task_items')

				_.each(studentTeacherPicks, (teacherPick) => {
					var book = _.findWhere(books, {text_id: teacherPick.subject_id})
					var taskItems = teacherPick.task_items

					var quizTaskItem = _.find(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ })
					var evaluation = {}
					var quizScore = 0
					if (quizTaskItem && quizTaskItem.subject_id !== null && !quizTaskItem.draft) {
						var quizMatch = _.find(quizzes, { id: parseInt(quizTaskItem.subject_id) })
						if (quizMatch && quizMatch.evaluation) {
							evaluation = WritingSelectors.evaluation({ state, id: quizMatch.evaluation });
							if (evaluation) {
								quizScore = evaluation.ratio * 4
								quizScore = Math.floor(quizScore * 2) / 2;
							}
						}
					}

					var exercisesAssigned = _.size(_.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE }))
					var exercisesCompleted = _.size(_.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, draft: false }))

					var pqsAssigned = _.size(_.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION }))
					var pqsCompleted = _.size(_.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION, draft: false }))

					var reviewAssigned = _.size(_.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW }))
					var reviewCompleted = _.size(_.where(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW, draft: false }))

					var row = {
						"First Name": student.first_name,
						"Last Name": student.last_name,
						"Class": (studentList ? studentList.name : "-"),
						"Assigned Date": (teacherPick.created_at ? teacherPick.created_at : "-"),
						"Due Date": (teacherPick.due_date ? teacherPick.due_date : "-"),
						"Text Title": (book ? book.title : "-"),
						"Quiz Score": (quizScore && evaluation ? quizScore + "/" + 4 : "-"),
						"Exercises": (exercisesAssigned ? exercisesCompleted + "/" + exercisesAssigned : "-"),
						"Practice Questions": (pqsAssigned ? pqsCompleted + "/" + pqsAssigned : "-"),
						"Review": (reviewAssigned ? reviewCompleted + "/" + reviewAssigned : "-"),
						"Complete": (teacherPick.draft ? "true" : "false"),
					}
					rows.push(row)
				})
			})
		} else {
			console.error("Unknown export type: ", type);
		}

		return { rows, headers };
	}
}
export const getDistrictExportDataF = ({ state }) => {
	return ({ type, schools, studentLists, startDate, endDate }) => {
		if (type == ALL_SCHOOLS) {
			var metrics = dashboardOtherMetrics({ state, count: 4 });
			var headers = ["School", "Classes", "Students"];
			metrics.forEach((x) => {
				headers.push(StudentMetrics.getLabel(x));
			});
			var rows = [];

			schools.forEach((school) => {				
				var classCount = RosterSelectors.studentLists( {
					state,
					filters: { school_org_id: school.id }
				}).length

				var digests = digestsByOrg({
					state,
					orgType: OrgTypes.SCHOOL_ORG,
					filters: { start_date: startDate, end_date: endDate },
				})

				var identifier = OrgTypes.toIdentifier({ type: OrgTypes.SCHOOL_ORG, key: school.id });
				var base = { org_identifier: identifier };
				var digest = _.findWhere(digests, base);

				var orgIdentifier = digest.org_identifier;
				var studentCount = RosterSelectors.studentsForOrgIdentifier({ 
					state, orgIdentifier
				}).length
				
				var row = {
					"School": school.name,
					"Classes": classCount,
					"Students": studentCount
				}

				metrics.forEach((metric) => {
					var label = StudentMetrics.getLabel(metric);
					row[label] = StudentMetrics.getValue(digest, metric);
				})
				rows.push(row);
			})
		} else if (type == ALL_CLASSES || type == SCHOOL) {
			var metrics = dashboardOtherMetrics({ state, count: 4 });
			if (type == ALL_CLASSES) {
				if (CurrentUser.isSchoolAdmin()) {
					var headers = ["Class", "Teacher", "Students", "Grade"];
				} else {
					var headers = ["Class", "School", "Students", "Grade"];
				}
			} else {
				var headers = ["Class", "Teacher", "Students", "Grade"];
			}
			metrics.forEach((x) => {
				headers.push(StudentMetrics.getLabel(x));
			});
			var rows = [];

			studentLists.forEach((studentList) => {				
				var digests = digestsByOrg({
					state,
					orgType: OrgTypes.STUDENT_LIST,
					filters: { start_date: startDate, end_date: endDate },
				})
				var schoolOrg = RosterSelectors.schoolOrg({ state, id: studentList.school_org_id });
				var studentListID = studentList.id;
				var admin = RosterSelectors.primaryAdminForStudentListID({ state, studentListID });
				var adminName = admin.first_name + " " + admin.last_name;

				var identifier = OrgTypes.toIdentifier({ type: OrgTypes.STUDENT_LIST, key: studentList.id });
				var base = { org_identifier: identifier };
				var digest = _.findWhere(digests, base);

				var orgIdentifier = digest.org_identifier;
				var studentCount = RosterSelectors.studentsForOrgIdentifier({ 
					state, orgIdentifier
				}).length

				if (type == ALL_CLASSES) {
					if (schoolOrg) {
						var row = {
							"Class": studentList.name,
							"School": schoolOrg.name,
							"Students": studentCount,
							"Grade" : studentList.grade_level
						}
					} else {
						var row = {
							"Class": studentList.name,
							"Teacher": adminName,
							"Students": studentCount,
							"Grade" : studentList.grade_level
						}
					}
				} else {
					var headers = ["Class", "Teacher", "Students", "Grade"];
					var row = {
						"Class": studentList.name,
						"Teacher": adminName,
						"Students": studentCount,
						"Grade" : studentList.grade_level
					}
				}

				metrics.forEach((metric) => {
					var label = StudentMetrics.getLabel(metric);
					row[label] = StudentMetrics.getValue(digest, metric);
				})
				rows.push(row);
			})
		}
		return { rows, headers };
	}
}

export function widgetDigests({ state, conditions }) {
	return _.where(state.widgetDigests, { ...conditions })
}

export function isLoadingWidgetDigests({ state, key }) {
	key = key || "index";
	return state.widgetDigests.loading[key];
}

export function surveyPrompts({ state, conditions }) {
	return _.where(state.surveyPrompts, { ...conditions })
}

export function surveyPrompt({ state, conditions }) {
	return _.findWhere(state.surveyPrompts, { ...conditions })
}

var ALL_CLASSES = "all-student-lists";
var ALL_SCHOOLS = "all-school-orgs";
var SCHOOL = "school-org";


// WEBPACK FOOTER //
// ./modules/lib/selectors/DataSelectors.js